export default ({
    children,
    name,
    type = '',
    label,
    icon,
    value,
    placeholder,
    errors = [],
    onChange = {},
    readonly = false,
    select = false,
    fit = false,
    max = null,
    min = null,
    valid = null,
    description = null,
    onSelect = ()=> console.log('Selected')
 }) => {
     let minMax = {}

     if (max !== null) minMax.maxlength = max;
     if (min !== null) minMax.minlength = min;

     console.log(description)

    return (
        <div id={name} className="input-outer" style={{ width: '100%' }}>
            { (label || description) &&
                <div className="input-outer__head">
                    { label ? <label for={name}>{ label ? label : ''  } </label> : "" }
                    { description ? <p className="input-outer__description" dangerouslySetInnerHTML={{ __html: description }}></p> : '' }
                </div>
            }

            { select ?
                <div className="input-outer__select">
                    <input  { ...minMax } type={type} className={valid !== null && !valid ? "input-outer__error" : ""} name={name} value={value || ''} onChange={onChange}/>
                    <button onClick={onSelect}>Select</button>
                </div> :
                children ?  <div className="utils__row">
                                <input { ...minMax } readOnly={readonly} type={type} className={valid !== null && !valid ? "input-outer__error" : ""} placeholder={placeholder} name={name} value={value || ''} onChange={onChange}/>
                                { children }
                            </div> : <input { ...minMax } readOnly={readonly} type={type} className={valid !== null && !valid ? "input-outer__error" : ""} placeholder={placeholder} name={name} value={value || ''} onChange={onChange}/>
            }

            { errors.length > 0 && <div className="input-outer__errors">{ errors.map(err => <p>{ err }</p>) }</div> }

        </div>
    )
}
